import { MatDialogConfig } from '@angular/material/dialog';

export const DIALOG_CONFIG: MatDialogConfig = {
  id: 'integration-setup',
  height: 'initial',
  width: '600px',
  autoFocus: false,
  restoreFocus: false,
};
